module.exports = __webpack_public_path__ + "img/vimeo.8f53e972.svg";